import React from 'react'
import Features from '../components/features';
import Categories from '../components/categories';
import NewArrivals from '../components/new-arrivals';
import Collection from '../components/collection';
import VideoSection from '../components/video-section';
import Testimonials from '../components/testimonials';
import Blog from '../components/blog';
import FoodSafetyPolicy from '../components/food-safety-policy';
import Newsletter from '../components/newsletter';
import HeroSlider from '../components/hero-slider';
import { useProducts } from '../hooks/use-products';
import { useCategories } from '../hooks/use-categories';

const Home = () => {
    const { products, loading } = useProducts();
    const { categories, loading: isCategoryLoading } = useCategories();
    
    return (
        <>
            <HeroSlider />
            <Categories categories={categories} loading={isCategoryLoading} />
            <NewArrivals products={products} loading={loading} />
            <Collection />
            <VideoSection />
            <Testimonials />
            <Blog />
            <FoodSafetyPolicy />
            <Newsletter />
        </>
    )
}

export default Home
